import styled from 'styled-components';

export const Container = styled.div`
  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;
  }

  .documents-header {
    background: ${(props) => props.theme.$gray200};
    color: ${(props) => props.theme.$gray700};
    font-weight: bold;
  }


.text {
  color: #721c24; !important;
}

}
`;
